<template>
  <v-select
    v-model="selected"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    :label="selectionLabel"
    :disabled="readonly"
    :placeholder="placeholder"
    :options="options"
    :loading="loading"
    :reduce="(item) => item[selectionKey]"
    class="n-async-multi-select"
  >
    <template #no-options>
      {{ $t("selection.noOption") }}
    </template>
    <template #spinner="{ loading }">
      <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import { BSpinner } from "bootstrap-vue";

export default {
  components: {
    vSelect,
    BSpinner,
  },
  props: {
    placeholder: {},
    name: {},
    disabled: {},
    readonly: {},
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectionKey: {
      type: String,
      default: "value",
    },
    selectionLabel: {
      type: String,
      default: "label",
    },
    initOptions: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: [],
      loading: false,
      loadedInitOptions: false,
    };
  },
  watch: {
    selected: function (value) {
      this.$emit("input", value);
    },
    initOptions: function (value) {
      if (!this.loadedInitOptions) {
        this.selected = this.initOptions;
        this.loadedInitOptions = true;
      }
    },
  },
  methods: {
    reset() {
      this.selected = "";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>